export const TABS = [
  { key: "dashboard", path: "/dashboard", label: "Tableau de bord" },
  { key: "clients", path: "/dashboard/clients", label: "Clients" },
  { key: "nouveaux_clients", path: "/dashboard/nouveaux", label: "Nouveaux clients" },
  { key: "suivi_cles", path: "/dashboard/suivi-cles", label: "Suivi des clés" },
  { key: "resilies", path: "/dashboard/resilies", label: "Sites résiliés" },
  { key: "cles_envoyees", path: "/dashboard/cles-envoyees", label: "Clés envoyées" },
  { key: "consignes", path: "/dashboard/consignes", label: "Consignes du jour" },
  { key: "passation", path: "/dashboard/passation", label: "Passation" },
  { key: "planning", path: "/dashboard/planning", label: "Planning" },
  { key: "soustraitants", path: "/dashboard/soustraitants", label: "Sous-traitants" },
  { key: "suivi_gardiennage", path: "/dashboard/suivi-gardiennage", label: "Suivi gardiennage" },
  { key: "cr_interventions", path: "/dashboard/comptes-rendus-interventions", label: "Comptes rendus interventions" },
  { key: "cr_gardiennage", path: "/dashboard/comptes-rendus-gardiennage", label: "Comptes rendus gardiennage" },
  { key: "agents", path: "/dashboard/agents", label: "Agents" },
  { key: "presence", path: "/dashboard/presence", label: "Présence agents" },
  { key: "decompte_paie", path: "/dashboard/decompte-paie", label: "Décompte paie" },
  { key: "devis", path: "/dashboard/devis", label: "Devis" },
  { key: "paie_ccn", path: "/dashboard/paie-ccn", label: "Paie CCN 1351" },
  { key: "conges", path: "/dashboard/conges", label: "Congés" },
  { key: "suivi", path: "/dashboard/suivi", label: "Suivi & Traçabilité" },
  { key: "prospection", path: "/dashboard/prospection", label: "Prospection" },
  { key: "notes_frais", path: "/dashboard/notes-frais", label: "Notes de frais" },
  { key: "relances", path: "/dashboard/relances", label: "Relances" },
  { key: "controle_devis", path: "/dashboard/controle-devis", label: "Contrôle devis" },
  { key: "controle_facture", path: "/dashboard/controle-facture", label: "Contrôle facture" },
  { key: "facturation_gardiennage", path: "/dashboard/facturation-gardiennage", label: "Facturation gardiennage" },
  { key: "assistant", path: "/dashboard/assistant", label: "Assistant PACAZUR", adminOnly: true },
  { key: "chefs_poste", path: "/dashboard/chefs-poste", label: "Chefs de poste", adminOnly: true },
  { key: "managers", path: "/dashboard/managers", label: "Managers", adminOnly: true },
];

export const GRANTABLE_TABS = TABS.filter((t) => !t.adminOnly);
